import React, { useState } from "react";
import contactsData from "../data/contacts.json"; // Assuming your JSON data is stored here
import '../styles/contacts.css';

const Contacts = () => {
  const [contacts] = useState(contactsData.contact); // Access the contact array

  if (!contacts) return <p>Loading...</p>;

  return (
    <div className="contacts">
      <h1>Contact Information</h1>
      {contacts.map((contact, index) => (
        <div key={index} className="contact-item">
          {contact.icon && <img src={contact.icon} alt={`${contact.platform} icon`} className="contact-icon" />}
          <p>
            <strong>{contact.platform}:</strong> 
            <a href={contact.link} target="_blank" rel="noopener noreferrer">
              {contact.platform === 'Phone' ? contact.link.replace('tel:', '') : contact.link}
            </a>
          </p>
        </div>
      ))}
    </div>
  );
};

export default Contacts;
